import { useMemo } from 'react';
import { useSettings } from '@contexts/SettingsContext';

export const useNavbarStyles = (variant?: 'default' | 'dark') => {
  const { customSettings } = useSettings();

  const renderFontSize = useMemo(() => {
    switch (customSettings.topNavTextSize) {
      case 0:
        return '12px';
      case 1:
        return '14px';
      case 2:
        return '16px';
      default:
        return '12px';
    }
  }, [customSettings.topNavTextSize]);

  const backgroundColor = useMemo(() => {
    switch (variant) {
      case 'dark':
        return '#1c1e23';
      default:
        return '#2a292f';
    }
  }, [variant]);

  return {
    renderFontSize,
    backgroundColor
  };
};
